export const hero = {
  title: '健身器材直接进口',
  subtitle: '定制产品',
  button: '查看产品'
};

export const product = {
  specs: '规格',
  weight: '重量',
  volume: '体积',
  onRequest: '询价'
};

export const total = {
  label: '总价值',
  onRequest: '询价'
};

export const delivery = {
  shipping: {
    label: '预计发货',
    value: '30天',
    description: '收到定金后'
  },
  delivery: {
    label: '预计交付',
    value: '60天',
    description: '设备发货后'
  },
  packaging: {
    label: '包装',
    value: '胶合板',
    description: '胶合板箱'
  },
  warranty: {
    label: '保修',
    value: '1年',
    description: '免费更换零件',
    note: '(不包括零件运输费用)'
  },
  manufacturer: {
    label: '制造商',
    value: 'BRTW',
    link: '访问网站'
  }
};

export const financial = {
  title: '总价值 (BRL)',
  installment1: {
    title: '第1期 — 启动流程',
    description: '30%启动生产'
  },
  installment2: {
    title: '第2期 — 发货放行',
    description: '产品付款以便放行'
  },
  installment3: {
    title: '第3期 — 到达目的地',
    description: '港口或机场'
  }
};

export const considerations = {
  title: '提案考虑事项',
  validity: '提案有效期：15天',
  deadline: '发货期限：设备必须在3个月内发货。超过此期限，合同将被视为无效。',
  observation: '注意：由于这是直接进口10件设备，任何更换或添加新项目都将导致价值重新计算。',
  assembly: '组装和技术维护：不包括（买方责任）。'
};

export const actions = {
  print: '打印',
  download: '下载PDF',
  whatsapp: '通过WhatsApp发送',
  email: '通过电子邮件发送',
  whatsappText: '您好！这是Moviis的商业提案：',
  emailSubject: 'Moviis商业提案',
  emailBody: '您好！这是Moviis的商业提案：'
};

export const contact = {
  meeting: {
    title: '安排会议',
    button: '立即安排'
  },
  email: {
    title: '联系我们',
    button: '发送电子邮件'
  }
};

export const footer = {
  description: '专业高性能健身器材。',
  equipment: {
    title: '设备',
    cardio: '有氧',
    strength: '力量训练',
    functional: '功能性'
  },
  info: {
    title: '信息',
    catalog: '目录',
    shipping: '发货30天',
    delivery: '交付60天',
    warranty: '保修1年'
  },
  contactInfo: {
    title: '联系方式',
    address: 'R. Voluntários da Pátria, n.º 2468, 6楼',
    zipcode: '邮编 02402-000',
    phone: '(11) 3255-2877',
    email: 'lp@moviis.com.br',
    hours: '周一至周五，08:30至18:00 (GMT -03:00)'
  },
  copyright: '© 2026 Moviis. 保留所有权利。',
  poweredBy: 'Powered by Readdy'
};

export default {
  'hero.title': hero.title,
  'hero.subtitle': hero.subtitle,
  'hero.button': hero.button,
  'product.specs': product.specs,
  'product.weight': product.weight,
  'product.volume': product.volume,
  'total.label': total.label
};